import { Element } from '../../../../common/html/element'
import { formatInteger } from './helper'

const TotalCompany = ({ totalCompany, totalCount }) => {
  return (
    <>
      {formatInteger(totalCompany)}
      <Element elementName="span" style={{ color: '#3A414B' }}>
        /{formatInteger(totalCount)}
      </Element>
    </>
  )
}

export default TotalCompany
